import trackers from "./trackers"
import {PERKS, RECOGNITION, MEDICAL, WALLET, PLATFORM, REWARD, ONBOARDING, TOUR, WELLNESS, HOMEPAGE} from "./products"
import mixPanelService from "./trackers/mixpanel"
import {UrlDelta} from "./types/Tracker"
export interface TrackRecognitionEventData {
  statusCode: string
  has_reward: boolean
  global_reward: number
  type: "scheduled" | "standard"
  kind: "greeting_card_create" | "standard_recognition" | "greeting_card_add_message"
  greeting_type?: string
  occasion?: boolean
  recipients?: number
  values?: number
  source?: "celebration_onboarding" | "story"
  msg_template_kind?: string
  msg_template_type?: string
  is_everyone: boolean
}

export const clickEventId = "cta_button_click"

class Tracking {
  setup = (env: string) => {
    trackers.setup(env)
  }

  trackEvent = (name: string, data?: any) => {
    mixPanelService.trackEvent(name, data)
  }

  trackRecognitionEvent = (name: string, dataAttributes?: TrackRecognitionEventData) => {
    const productData = {
      perkbox_product: RECOGNITION
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackRewardEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: REWARD
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackPerksEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: PERKS
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackMedicalEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: MEDICAL
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackWalletEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: WALLET
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackPlatformEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: PLATFORM
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackOnboardingEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: ONBOARDING
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackTourEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: TOUR
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackWellnessEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: WELLNESS
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackSearchEvent = (name: string, dataAttributes: any, isRewards = false) => {
    const productData = {
      perkbox_product: isRewards ? REWARD : PERKS
    }

    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackCTAEvent = (dataAttributes?: {source: string; type: string; perkbox_product: string}) => {
    if (!dataAttributes?.perkbox_product) {
      return
    }
    const eventData = {
      ...dataAttributes
    }
    this.trackEvent(clickEventId, {...eventData})
  }

  trackHomepageEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: HOMEPAGE
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackUrl = (urlDelta: UrlDelta) => {
    mixPanelService.trackUrl(urlDelta)
  }
}

export default new Tracking()
